import React, {useRef, useState} from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import {Box, Flex, IconButton} from '@chakra-ui/react'
import {ChevronLeftIcon, ChevronRightIcon} from '@chakra-ui/icons'

import {DotIcon} from '../../icons'

const Carousel = ({slides, autoPlay}) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  let sliderRef = useRef(null)
  const next = () => {
    sliderRef.slickPause()
    sliderRef.slickNext()
  }
  const previous = () => {
    sliderRef.slickPause()
    sliderRef.slickPrev()
  }
  const goToSlide = (event) => {
    sliderRef.slickPause()
    sliderRef.slickGoTo(event.currentTarget.dataset.index)
  }

  const afterChange = (currentIndex) => {
    setCurrentSlideIndex(currentIndex)
  }

  return (
    <Box className="slider-container">
      <Slider
        ref={(slider) => {
          sliderRef = slider
        }}
        infinite
        arrows={false}
        autoplay={autoPlay}
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        afterChange={afterChange}
      >
        {slides.map((slide) => (
          <Box key={`${slide.key}-slideContent`}>{slide.slideContent}</Box>
        ))}
      </Slider>
      <Flex justify="space-between" mb="xxs">
        <Flex ml="-xs">
          {slides.map((slide, index) => (
            <IconButton
              key={`${slide.key}-dot`}
              isRound
              variant="ghost"
              data-index={index}
              onClick={goToSlide}
              aria-label={`Go to slide ${index}`}
              size="xs"
              icon={
                <DotIcon
                  boxSize="6px"
                  color={
                    currentSlideIndex === index
                      ? 'mld.netrual.900'
                      : 'mld.neutral.500'
                  }
                />
              }
            />
          ))}
        </Flex>
        <Box>
          <IconButton
            isRound
            onClick={previous}
            color="mld.neutral.700"
            variant="ghost"
            aria-label="Previous"
            size="sm"
            icon={<ChevronLeftIcon />}
          />
          <IconButton
            isRound
            onClick={next}
            color="mld.neutral.700"
            variant="ghost"
            aria-label="Next"
            size="sm"
            icon={<ChevronRightIcon />}
          />
        </Box>
      </Flex>
      {slides[currentSlideIndex]?.footerContent}
    </Box>
  )
}

Carousel.defaultProps = {
  autoPlay: false,
}

Carousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      slideContent: PropTypes.node.isRequired,
      footerContent: PropTypes.node,
    }),
  ).isRequired,
  autoPlay: PropTypes.bool,
}

export default Carousel
